import { reducer as addressReducer } from 'app/state/address-state'
import { contentReducer } from '@ynap/content-state'
import { countryReducer } from '@ynap/country-state'
import { overlayReducer } from '@ynap/overlay'
import { cartReducer } from '@ynap/cart-state'
import { authReducer } from '@ynap/auth-state'
import { reducer as form } from 'redux-form'
import { connectRouter } from 'connected-react-router'
import { combineReducers, composeReducers } from '@ynap/reducer-utils'
import { userReducer } from '@ynap/user-state'

import { creditsReducer } from 'app/state/credits-state'
import { preferencesReducer } from 'app/state/preferences-state'
import { reservationsReducer } from 'app/state/reservations-state'
import { orderHistoryReducer } from 'app/state/order-history-state'
import { reducer as walletReducer } from 'app/state/wallet-state'

export default (history) =>
    composeReducers(
        combineReducers({
            form,
            overlays: overlayReducer,
            wallet: walletReducer,
            addressBook: addressReducer,
            router: connectRouter(history),
        }),
        cartReducer,
        contentReducer,
        creditsReducer,
        contentReducer,
        countryReducer,
        preferencesReducer,
        orderHistoryReducer,
        userReducer,
        reservationsReducer,
        authReducer
    )
